import React, { FC, useCallback } from "react";
import { useTranslation } from "react-i18next";
import {
    BigText,
    Content,
    FinishPageType,
    FlowPage,
    FlowPageProps,
    NormalText,
    SmallText,
} from "../cancelFlow";
import { IonButton, useIonRouter } from "@ionic/react";
import img from "../../../../../assets/images/cancel-flow-header.png";
import { withClassName } from "../../../../../components/withClassName";
import * as stripeService from "../../../../../services/StripeService";
import { asPlanType } from "../../../../../services/StripeService";
import { useCurrentStripePlan } from "../../../../../components/hooks";
import { trackEvent } from "../../../../../services/analytics/analyticsService";

const Feature: FC<{ name: string; icon: string }> = ({ name, icon }) => {
    return (
        <li className={"feature"}>
            <div className={"icon"}>{icon}</div>
            <div className={"name"}>{name}</div>
        </li>
    );
};
const Features = withClassName("div", "features");
export const CancelPage: FC<FlowPageProps> = ({ finish, reason }) => {
    const { t } = useTranslation();
    const currentPlan = useCurrentStripePlan();
    const type = asPlanType(currentPlan?.metadata.plan_features);
    const router = useIonRouter();

    const onNo = useCallback(() => {
        router.goBack();
    }, [router]);
    const onYes = useCallback(() => {
        finish &&
            finish(async () => {
                await stripeService.cancelSubscription();
                trackEvent("CancellationOutcome", {
                    reason: reason,
                    outcome: "cancelled",
                });
                return FinishPageType.Cancelled;
            });
    }, [finish]);
    const basicBenefits: [string, string][] = [
        ["⌚", t("upgrade.goProModal.advancedTimers")],
        ["🔼", t("upgrade.basicFeatures.uploadTool")],
        ["🎨", t("upgrade.proFeaturesContent.tableFeature6")],
        ["📅", t("upgrade.basicFeatures.calendarSync")],
        ["🪧", t("upgrade.basicFeatures.addFreeExperience")],
    ];

    const proBenefits: [string, string][] = [
        ["⌚", t("upgrade.goProModal.advancedTimers")],
        ["🔥", t("upgrade.goProModal.heatmaps")],
        ["🏃‍♂️‍", t("upgrade.goProModal.performanceData")],
        ["📈", t("upgrade.proFeatureMarketing.trends")],
        ["📺", t("upgrade.goProModal.videoAnalysis")],
    ];

    return (
        <FlowPage className={"cancel-page"}>
            <Content>
                <img src={img} />
                <BigText>{t("cancellation.screens.cancelPage.title")}</BigText>
                <Features>
                    {type === "pro"
                        ? proBenefits.map(([icon, name]) => (
                              <Feature key={name} name={name} icon={icon} />
                          ))
                        : basicBenefits.map(([icon, name]) => (
                              <Feature key={name} name={name} icon={icon} />
                          ))}
                </Features>
            </Content>
            <NormalText>
                {t("cancellation.screens.cancelPage.areYouSure")}
            </NormalText>
            <SmallText>
                {t("cancellation.screens.cancelPage.clickToCancel")}
            </SmallText>
            <div className={"footer"}>
                <IonButton fill={"clear"} onClick={onYes}>
                    {t("general.yes")}
                </IonButton>
                <IonButton onClick={onNo}>{t("general.no")}</IonButton>
            </div>
        </FlowPage>
    );
};
